import { render, staticRenderFns } from "./OpenOrderTable.html?vue&type=template&id=47ef222b&scoped=true&"
import script from "./OpenOrderTable.js?vue&type=script&lang=js&"
export * from "./OpenOrderTable.js?vue&type=script&lang=js&"
import style0 from "./OpenOrderTable.scss?vue&type=style&index=0&id=47ef222b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef222b",
  null
  
)

export default component.exports